'use strict';
import React from 'react';
import { Helmet } from 'react-helmet';
import windowOffset from '../../utils/windowOffset';

export default function FixedBody (props) {
  const offset = windowOffset();
  const disableMargin = !!props.disable_margin;

  return (
    <Helmet bodyAttributes={{
      'style': 'overflow: hidden;' + (disableMargin ? '' : ' margin-right: ' + offset + 'px'),
      'class': 'body-full-screen'
    }} />
  );
}



// WEBPACK FOOTER //
// ./src/ui/Common/FixedBody.jsx